// extracted by css-extract-rspack-plugin
export default {"groupLabel":"ZM_Fr"};